import { defineStore } from 'pinia'

interface MetaState { title: string; description: string }

export const useMetaStore = defineStore('metaStore', {
  state: (): MetaState => ({ title: '', description: '' }),
  actions: {
    setMetaStore({ title, description }: MetaState) {
      this.title = title
      this.description = description
    },
    resetMetaStore() {
      this.title = ''
      this.description = ''
    }
  }
})
